// extracted by mini-css-extract-plugin
export default {"operationArea":"sectionWithSearchbar_operationArea__u48q9"};